import React from "react";

function stepClass(current, id) {
  return current === id ? "btn btn-primary btn-sm" : "btn btn-outline-primary btn-sm";
}

export default function FormStepNav({
  current,
  onGoForm1,
  onGoForm2,
  onGoForm3,
  showForm3 = false,
}) {
  return (
    <div className="d-flex align-items-center flex-wrap" style={{ marginRight: "8px" }}>
      <button
        type="button"
        className={stepClass(current, "form_1")}
        onClick={onGoForm1}
        disabled={current === "form_1"}
        style={{ marginRight: "6px", marginBottom: "4px" }}
      >
        Form 1
      </button>
      <button
        type="button"
        className={stepClass(current, "form_2")}
        onClick={onGoForm2}
        disabled={current === "form_2"}
        style={{ marginRight: "6px", marginBottom: "4px" }}
      >
        Form 2
      </button>
      {showForm3 ? (
        <button
          type="button"
          className={stepClass(current, "form_3")}
          onClick={onGoForm3}
          disabled={current === "form_3"}
          style={{ marginBottom: "4px" }}
        >
          Selesai
        </button>
      ) : null}
    </div>
  );
}
